import React from 'react';
import { Section } from './ui/Section';
import { Dumbbell, Utensils, Users } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    icon: Dumbbell,
    title: 'Guía de Ejercicios',
    subtitle: 'Complementarios',
    desc: 'Rutinas específicas para potenciar tus resultados físicos.',
    value: '$75.000'
  }, {
    icon: Utensils,
    title: 'Plan de Alimentación',
    subtitle: 'Potenciadora',
    desc: 'Los alimentos exactos que debes consumir para acelerar el proceso.',
    value: '$60.000'
  }, {
    icon: Users,
    title: 'Comunidad VIP',
    subtitle: 'WhatsApp',
    desc: 'Acceso exclusivo a nuestro grupo de soporte y experiencias.',
    value: '$30.000'
  }];
  return <Section background="accent" className="border-y border-[#FF6B00]/20" data-id="element-23">
      <div className="text-center mb-12" data-id="element-24">
        <span className="bg-[#FF6B00] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4 inline-block" data-id="element-25">
          Oferta Limitada
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white uppercase leading-tight" data-id="element-26">
          3 POTENTES ACELERADORES DE{' '}
          <span className="text-[#FFD700]" data-id="element-27">RESULTADOS GRATIS</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-28">
        {bonuses.map((bonus, idx) => <div key={idx} className="relative bg-[#0B1A0B] border border-[#22C55E]/30 rounded-xl p-6 text-center overflow-hidden group hover:-translate-y-2 transition-transform duration-300" data-id="element-29">
            <div className="absolute top-0 right-0 bg-[#22C55E] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-30">
              GRATIS
            </div>

            <div className="mx-auto bg-[#1A2A1A] w-20 h-20 rounded-full flex items-center justify-center mb-6 border-2 border-[#22C55E]/20 group-hover:border-[#22C55E] transition-colors" data-id="element-31">
              <bonus.icon className="w-10 h-10 text-[#22C55E]" data-id="element-32" />
            </div>

            <h4 className="text-[#FF6B00] font-bold text-sm uppercase mb-1" data-id="element-33">
              BONO #{idx + 1}
            </h4>
            <h3 className="text-xl font-bold text-white mb-1" data-id="element-34">{bonus.title}</h3>
            <h3 className="text-lg font-medium text-gray-300 mb-4" data-id="element-35">
              {bonus.subtitle}
            </h3>

            <p className="text-gray-400 text-sm mb-6" data-id="element-36">{bonus.desc}</p>

            <div className="mt-auto pt-4 border-t border-gray-800" data-id="element-37">
              <p className="text-gray-500 text-xs uppercase" data-id="element-38">Valor Real</p>
              <p className="text-xl font-bold text-white line-through decoration-red-500 decoration-2" data-id="element-39">
                {bonus.value}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}